<page-content *ngIf="!isLoading" [fullPageWidth]="true">
    <header-elitment header
            [hasSideMenu]="false">
    </header-elitment>
    <error-401 *ngIf="is401"></error-401>
    <error-404 *ngIf="is404 || !viewedCoach"></error-404>
    <module-content *ngIf="!is401 && !is404 && viewedCoach">

        <div fxLayout.lt-md="column-reverse" fxLayoutGap="20px">
            <div fxFlex="60" fxFlex.lt-lg="50">
                <div fxLayout="row" fxLayout.lt-lg="column" fxLayoutGap="20px">
                    <div fxFlex="40">
                        <div class="box">
                            <div class="box-title">
                                {{ 'Profil_coach' | translate }}
                            </div>

                            <div fxLayout="column" fxLayoutAlign="center center" >
                                <div>
                                    <img *ngIf="viewedCoach.user.avatar"
                                         class="avatar"
                                         [src]="conf.storageRootUrl + viewedCoach.user.avatar" />
                                    <mat-icon *ngIf="!viewedCoach.user.avatar" class="avatar">
                                        account_circle
                                    </mat-icon>
                                </div>
                                <div>
                                    <div fxLayout="column" fxLayoutAlign="center center" >
                                        <div>
                                            <p class="coachName">{{ viewedCoach.user.firstName + ' '+ viewedCoach.user.lastName }}</p>
                                        </div>
                                        <div>
                                            <p class="coachEmail">{{ viewedCoach.user.email }}</p>
                                            <p class="coachPhone">{{ viewedCoach.user.phoneNumber }}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div fxFlex="60">
                        <div class="box">
                            <div class="box-title">
                                {{ 'Your_teams' | translate }}
                            </div>
                            <div *ngIf="viewedCoach.teams?.length === 0" class="teamListItem">{{ 'No_team_yet' | translate }}</div>
                            <div *ngFor="let team of viewedCoach.teams" class="teamListItem">
                                <a (click)="onDisplayTeamClicked(team)">{{ team.name }}</a>
                            </div>
                        </div>
                    </div>
                </div>
                <div fxLayout="row" fxLayout.lt-lg="column" fxLayoutGap="20px">
                    <div fxFlex="40">
                        <div class="box">
                            <table class="coachAthTeam">
                                <tr>
                                    <td>
                                        <span class="nbrAth">{{ viewedCoach.athletes.length }}</span>
                                    </td>
                                    <td class="sepLeft">
                                        <span class="nbrAth">{{ viewedCoach.teams.length }}</span>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <span class="txtAth">{{ 'Followed_athletes' | translate }}</span>
                                    </td>
                                    <td class="sepLeft">
                                        <span class="txtAth">{{ 'Active_teams' | translate }}</span>
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            <div fxFlex="40" fxFlex.lt-lg="50">
                <div class="box">
                    <div class="box-title">
                        {{ 'Your_athletes' | translate }}
                    </div>

                    <div class="search-bar">
                        <mat-form-field [class.hidden]="dataAthleteSource.count == 0"
                                        color="primary">
                            <input matInput
                                   type="text"
                                   maxlength="255"
                                   placeholder="{{ 'Filter' | translate }}"
                                   #filterInput
                                   (keyup)="onFilterKeyup(filterInput.value)">
                            <mat-icon matSuffix>search</mat-icon>
                        </mat-form-field>
                    </div>

                    <mat-table *ngIf="dataAthleteSource.count > 0"
                               [dataSource]="dataAthleteSource"
                               matSort>
                        <mat-row *matRowDef="let row; columns: columns"></mat-row>

                        <ng-container matColumnDef="avatar">
                            <mat-cell *matCellDef="let row; let i = index" class="image-cell">
                                <img *ngIf="row.user.avatar"
                                     class="small-avatar"
                                     [src]="conf.storageRootUrl + row.user.avatar" />
                                <mat-icon *ngIf="!row.user.avatar" class="small-avatar">
                                    account_circle
                                </mat-icon>
                            </mat-cell>
                        </ng-container>

                        <ng-container matColumnDef="name">
                            <mat-cell *matCellDef="let row; let i = index" class="name-cell">
                                <div>{{ row.user.firstName + ' ' + row.user.lastName }}</div>
                            </mat-cell>
                        </ng-container>

                        <ng-container matColumnDef="teams">
                            <mat-cell *matCellDef="let row; let i = index" class="teams-cell">
                                <div>{{ row.teamNames }}</div>
                            </mat-cell>
                        </ng-container>

                        <ng-container matColumnDef="filling">
                            <mat-cell *matCellDef="let row; let i = index" class="filling-cell">
                                <app-feedback-athlete-smiley
                                    [athlete]="row.athlete"
                                    [organization]="organization"
                                    [defaultClass]="moodIconClass"
                                ></app-feedback-athlete-smiley>
                            </mat-cell>
                        </ng-container>

                        <ng-container matColumnDef="actions">
                            <mat-header-cell *matHeaderCellDef class="action-cell"></mat-header-cell>
                            <mat-cell *matCellDef="let row; let i = index" class="action-cell action-align-right">
                                <button mat-button
                                        [disabled]="!row.rights.view"
                                        [routerLink]="'/' + organization.code + '/athletes/' + row.user.id"
                                        class="ath-button">
                                    <i class="material-icons">view_module</i>
                                    <span>{{ 'Athlete_Dashboard' | translate }}</span>
                                </button>
                            </mat-cell>
                        </ng-container>

                    </mat-table>
                </div>
            </div>
        </div>
    </module-content>
</page-content>
